// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-cd702c96]:root {
  --vl-theme-primary-color: #ffe615;
  --vl-theme-primary-color-60: rgb(100%, 94.1176470588%, 44.9411764706%);
  --vl-theme-primary-color-70: rgb(100%, 93.137254902%, 35.7647058824%);
  --vl-theme-primary-color-rgba-30: rgba(255, 230, 21, 0.3);
  --vl-theme-fg-color: #333332;
  --vl-theme-fg-color-60: rgb(52%, 52%, 51.7647058824%);
  --vl-theme-fg-color-70: rgb(44%, 44%, 43.7254901961%);
}
.vl-vi[data-v-cd702c96]::before, .vl-vi[data-v-cd702c96]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
  display: inline-block;
  vertical-align: middle;
}
.vl-vi.vl-vi-u-180deg[data-v-cd702c96]::before {
  display: inline-block;
  transform: rotate(180deg);
  vertical-align: middle;
}
.vl-vi-u-xs[data-v-cd702c96]::before {
  font-size: 0.8rem;
}
.vl-vi-u-s[data-v-cd702c96]::before {
  font-size: 1.3rem;
}
.vl-vi-u-m[data-v-cd702c96]::before {
  font-size: 1.7rem;
}
.vl-vi-u-l[data-v-cd702c96]::before {
  font-size: 2rem;
}
.vl-vi-u-xl[data-v-cd702c96]::before {
  font-size: 2.2rem;
}
.vl-vi-u-90deg[data-v-cd702c96]::before {
  display: inline-block;
  transform: rotate(90deg);
}
.vl-vi-u-180deg[data-v-cd702c96]::before {
  display: inline-block;
  transform: rotate(180deg);
}
.mo-accountpanel-dropdown[data-v-cd702c96] {
  display: inline-block;
  position: relative;
}
.mo-accountpanel-dropdown__toggle[data-v-cd702c96] {
  border-radius: 0;
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
  border: 0;
  background-color: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  font-size: 1.6rem;
  font-family: "Flanders Art Sans", sans-serif;
}
.mo-accountpanel-dropdown__toggle__label[data-v-cd702c96] {
  display: inline-block;
  max-width: 40rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
@media screen and (max-width: 767px) {
.mo-accountpanel-dropdown__toggle__label[data-v-cd702c96] {
    max-width: 80vw;
}
}
.mo-accountpanel-dropdown__toggle .vl-icon[data-v-cd702c96] {
  margin-left: 2rem;
}
.mo-accountpanel-dropdown__content[data-v-cd702c96] {
  display: block;
  position: absolute;
  bottom: -0.5rem;
  right: 0;
  transform: translate3d(0, 100%, 0);
  background-color: #fff;
  box-shadow: 0 3px 17px rgba(0, 0, 0, 0.3);
  width: 28rem;
  min-width: 28rem;
  max-width: 90vw;
  z-index: 10003;
}
.mo-accountpanel-dropdown__content[data-v-cd702c96]:focus {
  outline: none;
}
.mo-accountpanel-dropdown__content__wrapper[data-v-cd702c96] {
  display: block;
  max-height: 300px;
  overflow-y: scroll;
}
@media screen and (min-width: 767px) {
.mo-accountpanel-dropdown__content[data-v-cd702c96] {
    max-width: 100%;
    margin: 0;
}
.mo-accountpanel-dropdown__content__wrapper[data-v-cd702c96] {
    max-height: 350px;
}
}
.mo-accountpanel-dropdown__content[data-v-cd702c96]::before {
  display: block;
  content: "";
  position: absolute;
  right: 12px;
  top: -10px;
  border: 12px solid transparent;
  border-bottom-color: #fff;
  border-top-width: 0;
}
.mo-accountpanel-dropdown__list[data-v-cd702c96] {
  padding: 0;
}
.mo-accountpanel-dropdown__list[data-v-cd702c96]:not(:last-child) {
  border-bottom: 1px solid #cbd2da;
}
.mo-accountpanel-dropdown__list__item__link[data-v-cd702c96] {
  display: flex;
  width: 100%;
  color: #333332;
  text-decoration: none;
  padding: 0.9rem 1rem 0.6rem;
}
.mo-accountpanel-dropdown__list__item__link[data-v-cd702c96]:hover {
  color: #003bb0;
  background-color: #f1f2f4;
}
.mo-accountpanel-dropdown__list__item__link[data-v-cd702c96]:focus {
  color: rgb(0%, 25%, 60%);
}
.mo-accountpanel-dropdown__list__item:first-child .mo-accountpanel-dropdown__list__item__link[data-v-cd702c96] {
  padding-top: 1.3rem;
}
.mo-accountpanel-dropdown__list__item:last-child .mo-accountpanel-dropdown__list__item__link[data-v-cd702c96] {
  padding-bottom: 1rem;
}
.mo-accountpanel-dropdown__list__item .vl-icon[data-v-cd702c96] {
  margin-right: 0.8rem;
  font-size: 1.5rem;
}
@media screen and (min-width: 767px) {
.mo-accountpanel-dropdown__list__item .vl-icon[data-v-cd702c96] {
    line-height: 2.3rem;
}
}
.mo-accountpanel-dropdown__list__item__label[data-v-cd702c96] {
  display: inline-block;
  padding: 0;
  font-size: 1.5rem;
  min-height: 2.6rem;
  line-height: 2.5rem;
}
.mo-accountpanel-dropdown__list__item--active .mo-accountpanel-dropdown__list__item__label[data-v-cd702c96] {
  font-weight: 500;
}
.mo-accountpanel-dropdown__list .mo-accountpanel-dropdown__list__item--heading[data-v-cd702c96] {
  color: #8695a8;
  padding: 1.7rem 1rem 0.6rem 1rem;
  height: auto;
}
.mo-accountpanel-dropdown__list--rolepicker .mo-accountpanel-dropdown__list__item__link[data-v-cd702c96] {
  padding-left: 2.8rem;
}
.mo-accountpanel-dropdown__list--rolepicker .mo-accountpanel-dropdown__list__item--active .mo-accountpanel-dropdown__list__item__link[data-v-cd702c96] {
  padding-left: 0.8rem;
}
.mo-accountpanel-dropdown__list--rolepicker .mo-accountpanel-dropdown__list__item--active .mo-accountpanel-dropdown__list__item__link .vl-icon[data-v-cd702c96] {
  margin-right: 0.5rem;
}
.mo-accountpanel-dropdown__footer[data-v-cd702c96] {
  display: flex;
  flex-direction: row;
  padding: 1rem 1.35rem;
  background: #f7f9fc;
  justify-content: space-between;
  border-top: 1px solid #cbd2da;
}
a.link[data-v-cd702c96] {
  color: #333332;
  font-size: 1.4rem;
  text-decoration: none;
}
a.link[data-v-cd702c96]:hover {
  text-decoration: underline;
  color: #003bb0;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
